/**
 * Short, locale-aware date for translation-memory created/updated metadata.
 * Returns an em dash when the value is missing or unparseable (Dato meta is
 * `null` until the next load reads it back). Shared by the entry row and the
 * entry form modal so the formatting stays consistent.
 */
export const formatDate = (iso?: string | null): string => {
  if (!iso) return '—';
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleDateString();
};
